import { format, parseISO } from "date-fns";
import { CartesianGrid, Line, LineChart, ResponsiveContainer, XAxis, YAxis } from "recharts";
import { MessagesPerDay } from "@shared/report";

interface DailyUsageChartProps {
  usage: MessagesPerDay | null;
  darkMode: boolean;
  animationBegin?: number;
}

export function DailyUsageChart({ usage, darkMode, animationBegin = 0 }: DailyUsageChartProps) {
  if (!usage) return null;

  const maxCount = Math.max(...usage.map((d) => d.count));
  const yAxisWidth = String(maxCount).length * 6 + 6;

  return (
    <div
      className="px-4 pt-3 pb-2 mb-6 border border-neutral-200 dark:border-neutral-700
                 rounded-xl shadow-lg shadow-neutral-100 dark:shadow-black/30"
    >
      <span className="block uppercase text-xs font-bold mb-4">Messages Per Day</span>
      <ResponsiveContainer width="100%" height={200}>
        <LineChart data={usage} width={600} height={200} tabIndex={-1}>
          <XAxis
            dataKey="date"
            axisLine={false}
            tickLine={false}
            tick={{
              fontSize: 12,
              fill: darkMode ? "var(--color-neutral-400)" : "var(--color-neutral-500)",
            }}
            interval="preserveStartEnd"
            tickFormatter={(value) => format(parseISO(value), "MMM d")}
            padding={{ left: 20 }}
          />
          <YAxis
            axisLine={false}
            tickLine={false}
            tick={{
              fontSize: 12,
              fill: darkMode ? "var(--color-neutral-400)" : "var(--color-neutral-500)",
            }}
            width={yAxisWidth}
            allowDecimals={false}
          />
          <Line
            type="monotone"
            dataKey="count"
            stroke="var(--color-blue-500)"
            strokeWidth={3}
            dot={false}
            activeDot={false}
            animationBegin={animationBegin}
            animationDuration={800}
            animationEasing="ease-out"
          />
          <CartesianGrid
            stroke={darkMode ? "var(--color-neutral-700)" : "var(--color-neutral-200)"}
            strokeDasharray="3 3"
            vertical={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
